import { Card } from "antd";
import styled from "styled-components";

export const CardCustom = styled(Card)`
  margin-top: 13px !important;
  border-radius: 7px !important;
  background: #fff !important;
  box-shadow: 0px 0px 10px #d8d8d8 !important;
  padding: 0px !important;

  label:not(.ant-radio-wrapper) {
    color: #9074bf;
    font-size: 1rem;
    font-weight: bold;
    &.error {
      color: #d44c4c;
    }
  }

  .ant-card-body {
    padding-top: 14px;
  }

  .body-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
`;
